import { render, staticRenderFns } from "./HelpDialog.vue?vue&type=template&id=c8b62606&scoped=true"
import script from "./HelpDialog.vue?vue&type=script&lang=js"
export * from "./HelpDialog.vue?vue&type=script&lang=js"
import style0 from "./HelpDialog.vue?vue&type=style&index=0&id=c8b62606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b62606",
  null
  
)

export default component.exports